import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, hasProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#6B7280' }}>Yükleniyor...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/giris?returnUrl=${encodeURIComponent(location.pathname)}`} replace />;
  }

  // candidateId yoksa sadece profil sayfasına izin ver
  if (!hasProfile && location.pathname !== '/panel/profil') {
    return <Navigate to="/panel/profil" replace />;
  }

  return children;
};

export default ProtectedRoute;
